import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [
    { value: 1, label: 'Draft' },
    { value: 2, label: 'Published' },
    { value: 3, label: 'Unpublished' },
  ],
});
